class VwHbsOrderPatolojiDTO {
    id: number = 0;
    orderDetayId?: number = null;
    alinmaTarih?: string = null;
    dokuTemelOzellikId?: number = null;
    alinmaSekliId?: number = null;
    yerlesimYerId?: number = null;
    bulasiciVarMi?: string = "H";
    acil?: string = "H";
    talepAciklama?: string = "";
    ekleyenKullanici?: number = null;
    eklemeTarihi?: string = null;
    guncelleyenKullanici?: number = null;
    guncellemeTarihi?: string = null;
    iptal?: string = "H";
    iptalTarihi?: string = null;
    iptalKullanici?: number = null;
    materyalId?: number = null;
    materyalAdet?: number = 1;
    klinikBilgi?: string = "";
    laboratuvarBilgi?: string = "";
    yerlesimyeradi?: string = "";
    dokutemelozellikadi?: string = "";
    alinmasekiladi?: string = "";
    materyaladi?: string = "";
    numunedurum?: number = null;
    fkTeslimedenpersonel?: number = null;
    fkTeslimalanpersonel?: number = null;
    fkRedneden?: number = null;
    redaciklama?: string = null;
    rednedenadi?: string = "";
    teslimredtarih?: string = null;
    teslimedenpersoneladsoyad?: string = "";
    teslimalanpersoneladsoyad?: string = "";
    numunedurumadi?: string = "";
    muracaatId?: number = null;
    morfolofiKodu?: string = "";
    orderId?: number = null;
    gonderilecekOrganizasyonId?: number = null;
    rezervBarkodno?: number = null;
    icKurumBarkodNo?: string = "";
};
export default VwHbsOrderPatolojiDTO;